// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://wdshnonjtrfhreccaqul.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Indkc2hub25qdHJmaHJlY2NhcXVsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTkxMzg3NDYsImV4cCI6MjA3NDcxNDc0Nn0.V7iXt83NyHflgdtc6VBdJHpSxorUX42mVZtFl7gWMkg";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});